import EnergySavingsLeafOutlinedIcon from '@mui/icons-material/EnergySavingsLeafOutlined';
import { lazy } from 'react';
import type { ModuleDefinition } from '../types';

/**
 * Module definitions for QuickLinks widget buttons.
 *
 * These modules are displayed as action buttons in the investor dashboard
 * QuickLinks widget when enabled for the user.
 *
 * To add a new module button:
 * 1. Add the module definition below with appropriate metadata
 * 2. Add the translation key to public/locales/{lang}/translation.json
 * 3. Implement the action handler in ModuleActionButtons component
 */
export const quickLinkModuleDefinitions = {
  econsent: {
    moduleKey: 'econsent2',
    titleKey: 'goPaperless',
    descriptionKey: 'goPaperlessDescription',
    icon: EnergySavingsLeafOutlinedIcon,
    actionType: 'modal',
    modalComponent: lazy(
      async () => import('@/modules/econsent/EConsentModal'),
    ),
  },
  genivity: {
    moduleKey: 'genivity',
    titleKey: 'takeHaloAssessment',
    descriptionKey: 'takeHaloAssessmentDescription',
    icon: null,
    actionType: 'sso',
    ssoPath: '/SSO/Genivity',
  },
} as const satisfies Record<string, ModuleDefinition>;

/**
 * Type-safe keys for QuickLink modules.
 */
export type QuickLinkModuleKey = keyof typeof quickLinkModuleDefinitions;

/**
 * Array of all QuickLink module keys for iteration.
 */
export const quickLinkModuleKeys = Object.keys(
  quickLinkModuleDefinitions,
) as QuickLinkModuleKey[];
